export const homeObjOne = {
  id: 'about',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'About LA Function',
  headline: 'LA Function a Music, Art, Dance & Food Festival',
  description:
    `LA Function emerges as a multi-stage festival designed to create a captivating musical journey. Featuring a dynamic lineup of DJs creating an unforgettable sonic experience.
    LA Function food festival grounds is crafted to immerse guests on a flavorful adventure through the heart of Los Angeles food scene.
    Our goal with LA Function is to create a sanctuary of love, fostering an environment where every participant feel valued and celebrated for who they are.
    Come experience LA’s vibrant culture at LA FUNCTION!
    `,
  buttonLabel: 'FUNCTION TICKETS',
  imgStart: false,
  img: require('../../images/blxstLaFunction.png'),
  alt: 'Car',
  dark: true,
  primary: true,
  darkText: false
};
export const homeObjTwo = {
  //gallery this is no longer the gallery component go to gallerypage.js
  id: 'discover',
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Photo Gallery',
  headline: 'LA Function Photo Gallery',
  description: //this text actually comes from photo gallery page
    `Past special guests & performances include:
    Ty Dolla $ign, Larry June, Hit-Boy, Trina, Blxst, Dom Kennedy, YG, Eric Bellinger, Will.i.am, Jay Rock, Kamaiyah, OT Genasis, DJ Mustard, Buddy, Christina Milian, The Game, India Love, SOBxRBE, Trey Songz, P-Lo, Iamsu, Pro Skater Stevie Williams, Big Boy, J Cruz, Jay 305, Blue Bucks Clan, Casey Veggies, Kalan.frfr, D.Smoke, Kurupt & Daz, & many more!`,
  buttonLabel: 'ENTER GALLERY',
  imgStart: true,
  img: require('../../images/theGameLaFunc.png'),
  alt: 'Piggybank',
  dark: false,
  primary: false,
  darkText: true
};

export const homeObjThree = {
  //tickets
  id: 'signup',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'LA Function TICKETS ON SELL NOW',
  headline: 'Tickets to LA Function sell out every year, get yours now!',
  description:
    "Be ready to FUNCTION all day to Hip-Hop, RnB, Afro-Beats, Reggaeton, Nostalgic & Deep House",
  buttonLabel: 'TICKETS',
  imgStart: false,
  // img: require('../../images/svg-1.svg'),
 // img: require("../../images/LA-Function-july-19-2025---larry-june.JPG"),
  img: require("../../images/2025_dates.JPEG"),
  alt: 'la function image',
  dark: true,
  primary: true,
  darkText: false,
};

// export const homeObjFour = {
//   //gallery this is no longer the gallery component go to gallerypage.js
//   id: 'Bet',
//   lightBg: true,
//   lightText: false,
//   lightTextDesc: false,
//   topLine: 'June 28 & 29',
//   headline: 'BETx FAN FEST IS BACK!',
//   description: //this text actually comes from photo gallery page
//     `BETx FAN FEST IS BACK for an LA takeover with Doechii, Flo Milli, Latto, Coco Jones, Shaboozey, Marsha Ambrosius, Saucy Santana, and more performing live! Lace up for the skate party hosted by Mustard & 10 Summers, plus panels, fashion, food, BET+ screenings, and the celebrity basketball game with captains Wallo & Gillie! BET Experience presented by Walmart. Fan Fest is FREE! Register now at BETExperience.com`,
//   buttonLabel: 'Register Now!',
//   imgStart: true,
//   img: require('../../images/BETX_LOGO_ONYX.png'),
//   alt: 'Piggybank',
//   dark: false,
//   primary: false,
//   darkText: true
// };


